module.exports = "img/flags/QA.8730854.png";